<template>
  <v-container fluid>
      <Table_Fases v-if="getSession.user.super == 1"/>
      <!-- <Table_Anos class="mt-4" v-if="getSession.user.super == 1"/> -->
  </v-container>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getSession: "session/getState"
    })
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Anos.vue